<template>
  <a-modal
    v-model:open="visible"
    title="评标报告下载"
    @cancel="closeModal"
    :footer="null"
    width="800px"
  >
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="false"
    >
    <span slot="action" slot-scope="text, record">
        <a @click="handleDownload(record)">下载</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { downloadFile, getAction } from "@api/manage";

export default {
  name: "SectionDownloadModal",
  data() {
    return {
      visible: false, // 控制弹窗显示
      dataSource: [],
      loading: false,
      columns: [
        {
          title: "序号",
          dataIndex: "",
          key: "rowIndex",
          width: 60,
          align: "center",
          customRender: (_, __, index) => index + 1,
        },
        {
          title: "标段编号",
          align: "center",
          dataIndex: "bidSectionCode",
        },
        {
          title: "标段名称",
          align: "center",
          dataIndex: "bidSectionName",
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  methods: {
    // 加载文件数据
    loadData(sectionList) {
      console.log(sectionList)
      this.dataSource = sectionList;
    },

    // 处理文件下载
    handleDownload(record) {
      {
        getAction('/ebid-ce/boAppraiseReport/getReportFileBySectionId',{sectionId: record.id}).then((res) => {
          if (res.success){
            if (res.result.length > 0){
              res.result.forEach(item => {
                downloadFile(item,"评标报告.pdf")
              })
            }else{
              this.$message.info("此项目评标报告暂未生成")
            }
          }
        })
      }
    },

    // 打开弹窗并加载数据
    openModal(sectionList) {
      this.visible = true;
      this.loadData(sectionList);
    },

    // 关闭弹窗
    closeModal() {
      this.visible = false;
      this.dataSource = [];
    },
  },
};
</script>
